import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { adminUpdateProject } from '@utils/api';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { StyledModal } from '@components/modal/ModalStyle';
import Input from '@components/form/Input';

import CopyModal from './CopyModal';
import Form from 'react-bootstrap/Form';
import { useToast } from '@contexts/Toast.context';

const EditModal = ({ project, show, setShow }) => {
	const { addToast } = useToast();
	const [showCopyModal, setShowCopyModal] = useState(false);
	const [showChangeOwnerModal, setChangeOwnerModal] = useState(false);
	const [showChangeOrganizationModal, setShowChangeOrganizationModal] = useState(false);
	const [showChangeTitleModal, setShowChangeTitleModal] = useState(false);

	const updateProjectMutation = useMutation({
		mutationFn: data => adminUpdateProject(data),
		onSuccess: () => {
			addToast({
				id: 'project-update-success',
				bg: 'success',
				title: 'Project updated.',
			});

			setShowCopyModal(false);
			setChangeOwnerModal(false);
			setShowChangeOrganizationModal(false);
			setShowChangeTitleModal(false);
		},
		onError: error => {
			console.error(error);
			addToast({
				id: 'project-update-error',
				bg: 'danger',
				title: 'Failed to update project.',
			});
		},
	});

	const handleUpdateProject = data => {
		console.log({ data });

		let params = {
			uuid: project?.uuid,
		};
		params[data.name] = data.value;

		updateProjectMutation.mutate(params);
	};

	return (
		<StyledModal
			variant="dark"
			show={show}
			centered={true}
			onHide={() => {
				setShow(false);
			}}>
			<Modal.Header closeButton closeVariant="white">
				<Modal.Title>
					Tittel <strong>{project?.title}</strong>
					<Button variant="link" onClick={() => setShowChangeTitleModal(true)}>
						endre
					</Button>{' '}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				Eier: {project?.owner?.user_name} {' |'}
				<Button variant="link" onClick={() => setChangeOwnerModal(true)}>
					endre
				</Button>{' '}
				<br></br>
				Organisasjon: {project?.organization?.name
					? project?.organization?.name
					: 'Ingen'}{' '}
				{' |'}
				<Button variant="link" onClick={() => setShowChangeOrganizationModal(true)}>
					endre
				</Button>{' '}
				<br></br>
				<br></br>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="success" onClick={() => setShowCopyModal(true)}>
					Kopier til bruker
				</Button>
				<Button variant="success" onClick={() => console.log('Publish now')}>
					Publiser til wms
				</Button>
			</Modal.Footer>
			{/* Modals */}
			{showCopyModal && (
				<CopyModal project={project} show={showCopyModal} setShow={setShowCopyModal} />
			)}
			{showChangeTitleModal && (
				<InputModal
					defaultValue={project?.title}
					handler={handleUpdateProject}
					title="Change title"
					label="New project title"
					helperText="Enter the new title of the project"
					show={showChangeTitleModal}
					setShow={setShowChangeTitleModal}
					name="title"
				/>
			)}
			{showChangeOwnerModal && (
				<InputModal
					defaultValue={project?.owner?.email}
					handler={handleUpdateProject}
					title="Change owner"
					label="New owner email"
					helperText="Enter the email for the new owner of this project."
					show={showChangeOwnerModal}
					setShow={setChangeOwnerModal}
					name="owner_email"
				/>
			)}

			{showChangeOrganizationModal && (
				<InputModal
					defaultValue={project?.organization?.name}
					handler={handleUpdateProject}
					title="Change organization"
					label="New organization uuid"
					helperText="Enter the new organizations uuid for this project."
					show={showChangeOrganizationModal}
					setShow={setShowChangeOrganizationModal}
					name="organization_uuid"
				/>
			)}

			<Modal.Footer>
				<Button variant="secondary" onClick={() => setShow(false)}>
					Close
				</Button>
			</Modal.Footer>
		</StyledModal>
	);
};
export default EditModal;

const InputModal = ({
	defaultValue,
	handler,
	title,
	label,
	helperText,
	show,
	setShow,
	loading,
	name,
}) => {
	return (
		<StyledModal
			variant="dark"
			show={show}
			centered={true}
			onHide={() => {
				setShow(false);
			}}>
			<Form
				onSubmit={e => {
					e.preventDefault();
					const elements = e.target.elements;
					const data = { name: name };

					for (let i = 0; i < elements.length; i++) {
						const item = elements.item(i);
						if (item.id === name) data.value = item.value;
					}

					handler(data);
				}}>
				<Modal.Header closeButton closeVariant="white">
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Input
						label={label}
						defaultValue={defaultValue}
						id={name}
						helperText={helperText}
						type="text"
						required
					/>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShow(false)}>
						Nah
					</Button>
					<Button variant="success" type="submit" disabled={loading}>
						Do it!
					</Button>
				</Modal.Footer>
			</Form>
		</StyledModal>
	);
};
